import React, { MouseEvent, useCallback } from 'react'

import * as Styled from './styled'

import LocationIcon from '../../../../img/location-icon.svg'

type PredictedPlace = google.maps.places.AutocompletePrediction

export { suggestionItemHeightInPx } from './styled'

export interface AddressSuggestedPlacesItemProps {
  onPlaceSelection: (place: PredictedPlace) => PredictedPlace | void
  isDisabled: boolean
  isSelected: boolean
  place: PredictedPlace
  onFocusOrMouseOver: () => void
}

export const AddressSuggestedPlacesItem: React.VFC<AddressSuggestedPlacesItemProps> = ({
  onPlaceSelection,
  isDisabled,
  isSelected,
  place,
  onFocusOrMouseOver,
}) => {
  const handleSelection = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      onPlaceSelection(place)
    },
    [place, onPlaceSelection],
  )

  return (
    <Styled.SuggestionItem>
      <Styled.SuggestionItemButton
        isSelected={isSelected}
        disabled={isDisabled}
        onClick={handleSelection}
        onFocus={onFocusOrMouseOver}
        onMouseEnter={onFocusOrMouseOver}
        tabIndex={0}
      >
        <Styled.LocationIcon src={LocationIcon} />
        <Styled.SuggestionMainText>
          {place.structured_formatting.main_text}
          {','}
        </Styled.SuggestionMainText>
        <Styled.SuggestionSecondaryText>
          {place.structured_formatting.secondary_text}
        </Styled.SuggestionSecondaryText>
      </Styled.SuggestionItemButton>
    </Styled.SuggestionItem>
  )
}
